require('./scss/default.scss');
require('./js/default.js')
